import React from "react"

import {connect} from "react-redux"
import history from "~/history.js"
import ComponentWithData from "~/utils/ComponentWithData"
import ShelfApi from "~/utils/ShelfApi.js"
import {Article} from "~/utils/ShelfEntities"

import {Button, Field, SelectField} from "~/components/"
import {withTranslation} from "react-i18next"

class ArticleMovementView extends ComponentWithData {
  constructor(props) {
    super(props)

    this.state = {
      quantity: null,
      locations: [],
      selectedLocation: null,
      sourceLocation: null,
      note: null
    }
  }

  getLocations = () => {
    ShelfApi.get("/locations")
      .then(response =>
        this.setState({
          locations: response.data
        })
      )
      .catch(err => {
        console.log("Error loading data: " + err)
      })
  }

  getData() {
    this.getLocations()
    return Article.find(this.props.match.params.article_barcode)
  }

  renderLoading() {
    return <p>{this.props.t("loading")}</p>
  }

  renderError() {
    return (
      <p>
        {this.props.t("error")} {this.state.error}
      </p>
    )
  }

  renderEmpty() {
    return <p>{this.props.t("article.detail.notFound")}</p>
  }

  renderWithData() {
    const {
      barcode,
      expiry_date,
      product,
      stocks,
      is_singular_item
    } = this.state.data

    const detectSourceLocationBarcode = () => {
      if (this.state.selectedSourceLocationId) {
        return stocks.find(
          stock =>
            stock.storage_place &&
            stock.storage_place.type === "Location" &&
            stock.storage_place.id === this.state.selectedSourceLocationId
        ).storage_place.barcode
      } else {
        const location = stocks.find(
          stock =>
            stock.storage_place && stock.storage_place.type === "Location"
        )
        return location ? location.storage_place.barcode : null
      }
    }

    const filterByStoragePlace = location =>
      location.barcode !== detectSourceLocationBarcode()

    const onArticleMove = () => {
      if (
        window.confirm(
          this.props.t("articles.detail.movementConfirmation", {
            quantity:
              this.state.quantity ||
              stocks.find(
                stock =>
                  stock.storage_place && stock.storage_place.type === "Location"
              ).quantity,
            productName: product.name,
            locationName: this.state.selectedLocation.name
          })
        )
      ) {
        ShelfApi.post("/movements", {
          movement: {
            article_barcode: barcode,
            location_barcode: this.state.selectedLocation.barcode,
            source_location_barcode: detectSourceLocationBarcode(),
            expiry_date,
            quantity:
              this.state.quantity ||
              stocks.find(
                stock =>
                  stock.storage_place && stock.storage_place.type === "Location"
              ).quantity,
            note: this.state.note
          }
        })
          .then(res => history.push(`/article/${barcode}`))
          .catch(err => {
            let message = this.props.t("unknownError")

            if (
              !!err.response &&
              err.response.data &&
              err.response.data.errors
            ) {
              message = Object.values(err.response.data.errors).join(", ")
            }

            alert(message)
          })
      }
    }

    return (
      <div className="sh-detail-view">
        <div className="header">
          <div className="title">
            {this.props.t("articles.detail.movementTitle")}
          </div>
        </div>

        <div style={{maxWidth: 550, padding: 25}}>
          {!!!is_singular_item && (
            <Field
              label={this.props.t("articles.detail.quantity")}
              type="text"
              name="quantity"
              value={this.state.quantity}
              defaultValue={
                this.state.quantity ||
                stocks.find(
                  stock =>
                    stock.storage_place &&
                    stock.storage_place.type === "Location"
                ).quantity
              }
              onChange={e => {
                const parsedInput = e.target.value
                if (!isNaN(parsedInput) || "" || null) {
                  this.setState({quantity: parsedInput})
                }
              }}
            />
          )}

          {stocks.filter(
            stock =>
              stock.storage_place && stock.storage_place.type === "Location"
          ).length > 1 && (
            <SelectField
              label={this.props.t("articles.detail.sourceLocation")}
              name="source_location"
              options={stocks
                .filter(
                  stock =>
                    stock.storage_place &&
                    stock.storage_place.type === "Location"
                )
                .map(stock => stock.storage_place)}
              onChange={option =>
                this.setState({selectedSourceLocationId: option})
              }
            />
          )}

          <SelectField
            label={this.props.t("articles.detail.targetLocation")}
            name="traget_location"
            options={this.state.locations.filter(location =>
              filterByStoragePlace(location)
            )}
            onChange={option => {
              this.setState({
                selectedLocation: this.state.locations.find(
                  location => location.id === option
                )
              })
            }}
          />

          <Field
            label={this.props.t("articles.detail.note")}
            type="textarea"
            name="note"
            value={this.state.note}
            onChange={e => this.setState({note: e.target.value})}
          />
          <div style={{display: "flex", justifyContent: "flex-end"}}>
            <Button
              style={{marginTop: 20, marginRight: 20}}
              secondary
              to={"/article/" + barcode}
              label={this.props.t("cancel")}
            />
            <Button
              style={{marginTop: 20}}
              disabled={!this.state.selectedLocation}
              primary
              onClick={() => onArticleMove()}
              label={this.props.t("save")}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({auth}) => {
  const {user} = auth
  const {settings} = user
  const {
    usingViscosity,
    usingTestDate,
    usingArticleDocuments,
    usingLotNumber
  } = settings
  return {usingViscosity, usingTestDate, usingArticleDocuments, usingLotNumber}
}

export default withTranslation()(connect(mapStateToProps)(ArticleMovementView))



// WEBPACK FOOTER //
// ./src/views/detail/ArticleMovementView.js